import * as React from "react";
import './user-message.component.css';

interface IUserMessageComponentProps {
    message: string;
    time: string;
}

export const UserMessageComponent: React.FC<IUserMessageComponentProps> = ({ message, time }: IUserMessageComponentProps) => {
    return (
        <div className="flex flex-col user-message text-white p-4 rounded-lg shadow-md max-w-[390px] leading-1.5 float-right mr-1">
            <div className="flex space-x-2 rtl:space-x-reverse">
                <p className="text-base font-normal py-1">{message}</p>
                <span className="text-white text-xs block text-left self-end mt-6">{time}</span>
            </div>
        </div>
    );
}